"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1877],{

/***/ 97715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ ProductListActiveFilters; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88038);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77480);
/* harmony import */ var ui_components_ProductListFilterProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64648);
/* harmony import */ var ui_components_ProductListClearAllFilters__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(38844);
/* harmony import */ var utils_splitThreadExecution__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75142);








var ProductListActiveFilters = function() {
    var ref = (0,ui_components_ProductListFilterProvider__WEBPACK_IMPORTED_MODULE_5__/* .useProductListFilterContext */ .Q)(), enabledFilterOptions = ref.enabledFilterOptions, removeFilterValue = ref.removeFilterValue;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_4__/* .useTranslate */ .qM)();
    return Object.keys(enabledFilterOptions).length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
        className: "flex flex-wrap mt-5 items-center",
        role: "menu",
        "aria-label": t("selectedFilters"),
        children: [
            enabledFilterOptions && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: "noindex, follow"
                })
            }),
            Object.keys(enabledFilterOptions).map(function(filterKey) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FilterOptionValues, {
                    filter: enabledFilterOptions[filterKey],
                    onClick: function(filter, value) {
                        (0,utils_splitThreadExecution__WEBPACK_IMPORTED_MODULE_7__/* .splitThreadExecution */ .K)({
                            mainCallback: function() {
                                removeFilterValue(filter, value);
                            }
                        })();
                    }
                }, "".concat(filterKey));
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                role: "none",
                className: "pr-2 py-1",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_ProductListClearAllFilters__WEBPACK_IMPORTED_MODULE_6__/* .ProductListClearAllFilters */ .e, {
                    role: "menuitem"
                })
            })
        ]
    }) : null;
};
var FilterOptionValues = function(param) {
    var filter = param.filter, onClick = param.onClick;
    return filter.values.map(function(v) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
            role: "none",
            className: "pr-2 py-1",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ChipIcon, {
                onClick: onClick,
                id: filter.id,
                label: filter.label,
                value: v.label
            })
        }, "".concat(filter.id, "-").concat(v.value));
    });
};
var ChipIcon = function(param) {
    var id = param.id, label = param.label, value = param.value, onClick = param.onClick;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_4__/* .useTranslate */ .qM)();
    var handleClick = function() {
        onClick(id, value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        onClick: handleClick,
        "data-test-id": "selected-filter-item",
        role: "menuitem",
        className: "relative h-8 pr-7 pl-2 bg-puma-black-700 text-puma-black text-sm font-bold tracking-wide leading-tight flex items-center flex-0 focus:outline-none focus:ring-2 ring-puma-gold",
        type: "button",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "sr-only",
                children: t("clickToClear")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                children: [
                    label,
                    ": ",
                    value
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "absolute mt-px mr-0.5 right-1 top-1/2 -translate-y-1/2",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO$, {
                    name: "close",
                    size: "xl"
                })
            })
        ]
    });
};


/***/ }),

/***/ 38844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ ProductListClearAllFilters; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70169);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77480);
/* harmony import */ var ui_components_ProductListFilterProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64648);
/* harmony import */ var utils_splitThreadExecution__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75142);








var ProductListClearAllFilters = function(props) {
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_3__/* .useTranslate */ .qM)();
    var ref = (0,ui_components_ProductListFilterProvider__WEBPACK_IMPORTED_MODULE_4__/* .useProductListFilterContext */ .Q)(), clearAllFilters = ref.clearAllFilters, enabledFilters = ref.enabledFilters;
    return enabledFilters.length === 0 ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        "data-test-id": "clear-all-filters",
        className: "focus:outline-none focus:ring-2 ring-puma-gold relative pr-7 pl-2 h-8 capitalize text-puma-black text-xs tracking-wide uppercase font-bold whitespace-nowrap flex-0 flex items-center",
        onClick: function() {
            (0,utils_splitThreadExecution__WEBPACK_IMPORTED_MODULE_7__/* .splitThreadExecution */ .K)({
                mainCallback: clearAllFilters
            })();
        },
        type: "button"
    }, props), {
        children: [
            t("clearAll"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "sr-only",
                children: t("filters")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "absolute right-2 mt-px top-2/4 -translate-y-1/2",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO$, {
                    name: "close-outline",
                    size: "lg",
                    color: "muted"
                })
            })
        ]
    }));
};


/***/ }),

/***/ 51877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ProductListFilter": function() { return /* binding */ ProductListFilter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19989);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27378);
/* harmony import */ var twind_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49224);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12601);
/* harmony import */ var utils_splitThreadExecution__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(75142);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77480);
/* harmony import */ var hooks_useSticky__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8261);
/* harmony import */ var ui_components_ProductListFilterSort__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8688);
/* harmony import */ var ui_components_ProductListActiveFilters__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97715);
/* harmony import */ var ui_components_ProductListFilterDropdown__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18815);
/* harmony import */ var ui_components_ProductListFilterDrawer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5749);
/* harmony import */ var ui_components_ProductListFilterProvider__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(64648);
/* harmony import */ var hooks_useAvailableSpace__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(75073);
/* harmony import */ var utils_priceFilter__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(27523);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(20368);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n              &::before {\n                content: ' ';\n                pointer-events: none;\n              }\n            "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}















var MemoComponent = function(props) {
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_5__/* .useTranslate */ .qM)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), openFilter = ref[0], setOpenFilter = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), hidden = ref1[0], setHidden = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), lastScroll = ref2[0], setLastScroll = ref2[1];
    var filterListRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var staticFeatures = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_14__/* .useSiteConfig */ .N)().staticFeatures;
    var ref3 = (0,ui_components_ProductListFilterProvider__WEBPACK_IMPORTED_MODULE_11__/* .useProductListFilterContext */ .Q)(), totalCount = ref3.totalCount, filterItemsCache = ref3.filterItemsCache;
    var filterItems = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return filterItemsCache.filter(function(items) {
            return items && items.values.length > 0;
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        JSON.stringify(filterItemsCache)
    ]);
    var items = (0,hooks_useAvailableSpace__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(filterListRef, filterItems).items;
    var allFiltersFit = items.filter(function(i) {
        return i.hidden;
    }).length === 0;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), shouldUseFiltersDrawer = ref4[0], setShouldUseFiltersDraw = ref4[1];
    var ref5 = (0,hooks_useSticky__WEBPACK_IMPORTED_MODULE_6__/* .useSticky */ .A)(2), stickyRef = ref5.stickyRef, stickyTop = ref5.stickyTop, stickyWidth = ref5.stickyWidth, stickyCss = ref5.stickyCss;
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), filtersDrawerOpen = ref6[0], setFiltersDrawerOpen = ref6[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setShouldUseFiltersDraw(stickyWidth < 960);
    }, [
        stickyWidth
    ]);
    var handleScroll = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var ref;
        var bounds = (ref = stickyRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect();
        if (bounds && !hidden && // * Opening the mobile menu sets the lastScroll as 0
        // * we want to ignore this as the scroll will always be > 0
        // * once the filters become sticky
        lastScroll !== 0 && window.scrollY > lastScroll && bounds.top <= stickyTop) {
            setHidden(true);
        // * If we're at the top of the page we don't need to show the filters via this
        } else if (hidden && window.scrollY !== 0 && window.scrollY < lastScroll) {
            setHidden(false);
        }
        setLastScroll(window.scrollY);
    }, [
        hidden,
        lastScroll,
        stickyRef,
        stickyTop
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return function() {
            return window.removeEventListener("scroll", handleScroll);
        };
    }, [
        handleScroll
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!shouldUseFiltersDrawer) {
            setFiltersDrawerOpen(false);
        }
    }, [
        shouldUseFiltersDrawer
    ]);
    var _filterItems = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return (0,utils_priceFilter__WEBPACK_IMPORTED_MODULE_13__/* .removePriceFilterIfMinMaxExists */ .AH)(filterItems, staticFeatures.isPriceFilterSliderEnabled);
    }, [
        filterItems,
        staticFeatures.isPriceFilterSliderEnabled
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (filtersDrawerOpen) // Disable scroll when the drawer is open
        document.body.style.overflowY = "hidden";
        else {
            document.body.style.overflowY = "auto";
        }
    }, [
        filtersDrawerOpen
    ]);
    return props.enabledFilterOptions.length === 0 ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("nav", {
                ref: stickyRef,
                className: (0,twind_css__WEBPACK_IMPORTED_MODULE_3__.tw)("z-10 -mx-auto relative transform transition-transform duration-300", stickyCss, hidden && "-translate-y-full lg:transform-y-0"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    "aria-label": t("productFilters"),
                    "data-test-id": "filter-drawer",
                    className: (0,twind_css__WEBPACK_IMPORTED_MODULE_3__.tw)("relative z-10 bg-white ", "before:absolute before:top-0 before:w-screen before:h-full", "before:left-1/2 before:-translate-x-1/2", "before:border-b before:border-t", (0,twind_css__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject())),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "max-w-screen-3xl w-full mx-auto",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "py-5 flex",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "flex items-center flex-1 space-x-2 lg:space-x-3",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: (0,twind_css__WEBPACK_IMPORTED_MODULE_3__.tw)("flex", allFiltersFit && "lg:hidden"),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zxk, {
                                                "data-test-id": "open-filters-btn",
                                                variant: "secondary",
                                                icon: "filter",
                                                iconEnd: true,
                                                label: "".concat(t("filters")),
                                                onClick: function() {
                                                    var mainCallback = function() {
                                                        setFiltersDrawerOpen(!filtersDrawerOpen);
                                                    };
                                                    (0,utils_splitThreadExecution__WEBPACK_IMPORTED_MODULE_15__/* .splitThreadExecution */ .K)({
                                                        mainCallback: mainCallback
                                                    })();
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "hidden lg:flex items-center flex-1",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                                    className: (0,twind_css__WEBPACK_IMPORTED_MODULE_3__.tw)("mr-3", !allFiltersFit && "hidden"),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO$, {
                                                        name: "filter",
                                                        size: "2xl",
                                                        label: t("filters")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: (0,twind_css__WEBPACK_IMPORTED_MODULE_3__.tw)("flex w-1 flex-1", !allFiltersFit && "invisible"),
                                                    ref: filterListRef,
                                                    children: _filterItems.map(function(item) {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ui_components_ProductListFilterDropdown__WEBPACK_IMPORTED_MODULE_9__/* .ProductListFilterDropdown */ .tL, {
                                                            data: item,
                                                            openFilter: openFilter,
                                                            setOpenFilter: setOpenFilter,
                                                            classNames: "mr-3"
                                                        }, item.id);
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    children: props.sortOptions.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ui_components_ProductListFilterSort__WEBPACK_IMPORTED_MODULE_7__/* .ProductListSort */ .C, {
                                        options: props.sortOptions,
                                        defaultSortOption: props.defaultSortOption
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ui_components_ProductListActiveFilters__WEBPACK_IMPORTED_MODULE_8__/* .ProductListActiveFilters */ .l, {}),
            filtersDrawerOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ui_components_ProductListFilterDrawer__WEBPACK_IMPORTED_MODULE_10__/* .ProductListFilterDrawer */ .W, {
                onClose: function() {
                    return setFiltersDrawerOpen(false);
                },
                items: _filterItems,
                totalCount: totalCount
            })
        ]
    });
};
var ProductListFilter = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(MemoComponent);


/***/ }),

/***/ 5749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ ProductListFilterDrawer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77480);
/* harmony import */ var ui_elements_Accordion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36998);
/* harmony import */ var ui_components_ProductListClearAllFilters__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38844);
/* harmony import */ var ui_components_Modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51377);
/* harmony import */ var utils_splitThreadExecution__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(75142);
/* harmony import */ var ui_components_ProductListFilterDropdown__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18815);
/* harmony import */ var ui_components_ManagedHeading__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93512);
/* harmony import */ var _ProductListFilterProvider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64648);
/* harmony import */ var _CloseButton__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6485);












var ProductListFilterDrawer = function(param) {
    var onClose = param.onClose, items = param.items, totalCount = param.totalCount;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_3__/* .useTranslate */ .qM)();
    var isFetching = (0,_ProductListFilterProvider__WEBPACK_IMPORTED_MODULE_9__/* .useProductListFilterContext */ .Q)().isFetching;
    var handlePriceSliderSubmit = (0,_ProductListFilterProvider__WEBPACK_IMPORTED_MODULE_9__/* .useProductListFilterContext */ .Q)().handlePriceSliderSubmit;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ui_components_Modal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        dataTestId: "filter-modal",
        layout: "drawerLeft",
        variant: "dark",
        onClickOutside: onClose,
        className: "flex flex-col items-center min-h-screen",
        "aria-labelledby": "filter-drawer-heading",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full relative flex items-center justify-between border-b p-6",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_ManagedHeading__WEBPACK_IMPORTED_MODULE_8__/* .ManagedHeading */ .P, {
                        tag: "h1",
                        id: "filter-drawer-heading",
                        className: "inline-block text-left text-xl font-bold capitalize",
                        children: t("productFilters")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CloseButton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        dataTestId: "close-filters-btn",
                        onClick: onClose
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full flex flex-1 flex-col px-6 pb-4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_elements_Accordion__WEBPACK_IMPORTED_MODULE_4__/* .AccordionRoot */ .c2, {
                    children: items.map(function(item) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_elements_Accordion__WEBPACK_IMPORTED_MODULE_4__/* .AccordionTab */ .US, {
                            title: item.label,
                            id: item.id,
                            expand: false,
                            bodyClassNameConfig: {
                                baseClassName: "py-4"
                            },
                            headerClassNameConfig: {
                                baseClassName: "text-lg font-semibold pt-2 pb-4 capitalize"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: (0,ui_components_ProductListFilterDropdown__WEBPACK_IMPORTED_MODULE_7__/* .getFilterComponent */ .i2)({
                                    data: item,
                                    isFromDrawer: true
                                })
                            })
                        }, item.id);
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "sticky bottom-0 w-full flex flex-col items-center bg-white px-6 py-4 shadow-2xl",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_ProductListClearAllFilters__WEBPACK_IMPORTED_MODULE_5__/* .ProductListClearAllFilters */ .e, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zxk, {
                        dataTestId: "product-list-drawer-btn",
                        label: t("showProducts", {
                            count: totalCount
                        }),
                        className: "mt-6 w-full",
                        variant: "primary",
                        onClick: function() {
                            var mainCallback = function() {
                                handlePriceSliderSubmit();
                                onClose();
                            };
                            (0,utils_splitThreadExecution__WEBPACK_IMPORTED_MODULE_11__/* .splitThreadExecution */ .K)({
                                mainCallback: mainCallback
                            })();
                        },
                        size: "lg",
                        disabled: isFetching
                    })
                ]
            })
        ]
    }, "draw-filter");
};


/***/ }),

/***/ 8688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ ProductListSort; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88038);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77480);
/* harmony import */ var ui_components_ProductListFilterProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64648);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20368);
/* harmony import */ var utils_analytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83168);
/* harmony import */ var hooks_usePageEventsContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43308);
/* harmony import */ var utils_isNotNullish__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50597);










var MemoComponent = function(param) {
    var options = param.options, defaultSortOption = param.defaultSortOption;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_4__/* .useTranslate */ .qM)();
    var plpShowDefaultSortOption = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_6__/* .useSiteConfig */ .N)().plpShowDefaultSortOption;
    var pageviewEventHasFired = (0,hooks_usePageEventsContext__WEBPACK_IMPORTED_MODULE_8__/* .usePageEventsContext */ .qN)().pageviewEventHasFired;
    var ref = (0,ui_components_ProductListFilterProvider__WEBPACK_IMPORTED_MODULE_5__/* .useProductListFilterContext */ .Q)(), queryParams = ref.queryParams, dispatchAnalyticsEvent = ref.dispatchAnalyticsEvent, setSortOrder = ref.setSortOrder;
    var handleSortChange = function(value) {
        dispatchAnalyticsEvent({
            event: utils_analytics__WEBPACK_IMPORTED_MODULE_7__/* .AnalyticsEvents.SORT_SELECTED */ ._q.SORT_SELECTED,
            params: {
                domevent: value,
                domlabel: ""
            }
        });
        if (pageviewEventHasFired) {
            (0,utils_analytics__WEBPACK_IMPORTED_MODULE_7__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_7__/* .AnalyticsEvents.GA4_CustomEvent */ ._q.GA4_CustomEvent, {
                event_name: "sort",
                event_params: {
                    sort_selected: value
                }
            });
        }
        setSortOrder(value);
    };
    var hasSortParam = (0,utils_isNotNullish__WEBPACK_IMPORTED_MODULE_9__/* .isNotNullish */ .l)(queryParams.sort);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            hasSortParam && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: "noindex, follow"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .FilterSelect */ .zEy, {
                label: t("sortBy"),
                className: "uppercase",
                dataTestId: "product-list-sort-select",
                id: "product-list-sort-select",
                placeholder: t("sortBy"),
                defaultValue: queryParams.sort || plpShowDefaultSortOption && defaultSortOption || "",
                name: "sortBy",
                onChange: handleSortChange,
                options: (options || []).map(function(option) {
                    return {
                        label: option.label,
                        value: option.id
                    };
                })
            }, queryParams.sort || "default")
        ]
    });
};
var ProductListSort = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(MemoComponent);


/***/ })

}]);